'use client';

import * as rrd from 'react-router-dom';

import { Meta } from './segments';
import { notFoundMeta } from '@/utils';

const { Link } = rrd.default ?? rrd;

const NotFound = () => {
  return (
    <>
      <Meta robots {...notFoundMeta} />

      <main
        className="container py-4 d-flex align-items-center"
        style={{ minHeight: 'calc(100vh - 410px)' }}
      >
        <div className="row justify-content-center text-center w-100">
          <div className="col-md-8 col-lg-6">
            <div className="mb-3">
              <span className="display-1 fw-bold text-accent">404</span>
            </div>

            <h1 className="mb-3">Page Not Found</h1>

            <p className="text-muted mb-4">
              The page you are looking for might have been removed, had its name
              changed, or is temporarily unavailable.
            </p>

            <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
              <Link to="/" className="btn btn-accent px-4 py-2">
                Go Home
              </Link>

              <button
                type="button"
                onClick={() => window.history.back()}
                className="btn btn-outline-secondary px-4 py-2"
              >
                Go Back
              </button>
            </div>

            <div className="mt-4">
              <h5 className="mb-2">Looking For Something Specific?</h5>

              <div className="d-flex flex-wrap justify-content-center gap-3 text-muted">
                <Link to="/" className="text-decoration-none">
                  Home
                </Link>

                <Link to="/privacy-policy" className="text-decoration-none">
                  Privacy
                </Link>

                <Link to="/terms-of-service" className="text-decoration-none">
                  Terms
                </Link>

                <Link to="/cookie-policy" className="text-decoration-none">
                  Cookies
                </Link>

                <Link to="/support" className="text-decoration-none">
                  Support
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default NotFound;
